import { BrandDescription } from "components/UI/molecules";
import "./index.scss";

export const MobileBrandDescription = ({ name, description, iconUrl }) => {
  return (
    <div
      className="mobile-brand-description"
      data-testid="mobile-brand-description"
    >
      <div className="mobile-brand-image-container">
        <img src={iconUrl} alt={`${name} logo`} className="brand-logo" />
      </div>
      <BrandDescription
        brandName={name}
        defaultMaximumLines={2}
        description={description}
      />
    </div>
  );
};
